import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Link, useNavigate} from 'react-router-dom';
import Box from "@mui/material/Box";
import DateRangeFilter from "../../../../filter/DateRangeFilter";
import DateTimeUtil from "../../../../../../utils/common/DateTimeUtil";
import ModalConfirm from "../../../../modal/ModalConfirm";
import {estimateStatuses} from "../../../../../../data/EstimateState";
import MenuItem from "@mui/material/MenuItem";
import EstimateService from "../../../../../../API/orders/estimate/organization/EstimateService";
import ButtonCreate from "../../../../button/ButtonCreate";
import {calcFilterData} from "../../../../../../utils/common/calcFilterData";

const OrderCloudTable = ({
                             data,
                             setData,
                             tableOptions,
                             tableOptionsHandle,
                             handleModalAlert,
                             archive,
                             globalFilter,
                             handleSearchQuery,
                             filteredData,
                             columnsFilter
                         }) => {
    const [setPurchaseModalOpen, setSetPurchaseModalOpen] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }
    const handleSubmitSetPurchase = async () => {
        EstimateService.confirmExecution(currentRow.id)
            .then(function () {
                setSetPurchaseModalOpen(false)
                const newData = data.filter(el => el.id !== currentRow.id)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleModalAlert("Подтверждено", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'numberCustomer',
                header: 'Номер заказа',
                accessorKey: 'numberCustomer',
                filterFn: 'contains',
                minSize: 300,
                Cell: ({cell, row}) => (
                    <Link
                        to={'/organization/orders-cloud/' + row.original.id + '/' + encodeURIComponent(row.original.numberCustomer)}>{cell.getValue() === null ? 'Не занумерован' : cell.getValue()}</Link>

                ),
            },
            {
                id: 'customerName',
                header: 'Заказчик',
                accessorKey: 'customerName',
                filterFn: 'contains',
                minSize: 300,
            },
            {
                id: 'calculationTotalCostBasePrice',
                header: `Себестоимость:`,
                accessorKey: 'estimate.calculationTotalCostBasePrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.price.toFixed(2)
                },
            },
            {
                id: 'baseTotalPrice',
                header: `Продажа`,
                accessorKey: 'estimate.baseTotalPrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.price.toFixed(2)
                },
            },
            {
                id: 'profitCalculationBaseTotalPrice',
                header: `Прибыль:`,
                accessorKey: 'estimate.profitCalculationBaseTotalPrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.price.toFixed(2)
                },
            },
            {
                id: 'calculationGrossMargin',
                header: `Валовая маржа`,
                accessorKey: 'estimate.calculationGrossMargin',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
                },
            },
            {
                id: 'estimateState',
                header: 'Статус',
                accessorKey: 'estimate.estimateState',
                minSize: 250,
                Cell: ({cell}) => estimateStatuses[cell.getValue()],
                filterFn: (row, id, filterValue) => {
                    return estimateStatuses[row.original.estimate?.estimateState].toLowerCase().includes(filterValue.toLowerCase())
                },
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfCreate === null) {
                    } else {
                        return new Date(row.dateOfCreate)
                    }
                },
                id: 'dateOfCreate',
                header: 'Дата расчета',
                sortingFn: 'datetime',
                accessorKey: 'dateOfCreate',
                maxSize: 25,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString();
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfPerformance === null || row.dateOfPerformance === undefined) {
                        return null;
                    } else {
                        return new Date(row.dateOfPerformance);
                    }
                },
                id: 'dateOfPerformance',
                header: 'Дата изготовления',
                accessorKey: 'dateOfPerformance',
                sortingFn: 'datetime',
                size: 10,
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    if (value) {
                        return value.toLocaleDateString();
                    }
                    return '';
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'year',
                header: 'год                                                                     ',
                accessorKey: 'year',
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
        ];

        return baseColumns;

    }, [data, setData, filteredData]);

    const handleConfirm = (row) => {
        setCurrentRow(row)
        setSetPurchaseModalOpen(true)
    }
    const menuItem = [
        {type: "confirm", text: "Подтвердить исполнение", handler: handleConfirm},
    ]
    const navigate = useNavigate();

    return (
        <Box sx={{maxWidth: "2100px"}}>
            {!archive && <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
            >
                <ButtonCreate
                    text={"Архив"}
                    width={70}
                    icon={false}
                    onClick={() => navigate('/organization/orders-cloud-archive')}
                />
            </Box>}
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableContainerProps={{
                    sx: {
                        width: '2100px',
                    }
                }}
                muiTableBodyCellProps={({cell, table}) => {
                    return ({
                        sx: () => ({
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',
                            },
                            "&": cell.column.id === "requests_cutting" && {
                                width: 'calc(100% - 1px)',
                                padding: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            },
                            "&:first-of-type": {
                                padding: 0,
                                width: "50px",
                                height: "36px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: (theme) => theme.palette.text.light,
                                "& .MuiButtonBase-root": {
                                    borderRadius: "4px",
                                    width: "24px",
                                    height: "24px",
                                    opacity: 1,
                                    margin: 0,
                                    padding: 0,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    }
                                }
                            },

                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }

                            }
                        })
                    })
                }}

                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem",
                        "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                            "minWidth": "100%"
                        },
                        "& .MuiCollapse-root .MuiSelect-select": {
                            padding: "0 !important",
                            "& .MuiChip-label": {
                                paddingLeft: "5px",
                                paddingRight: "5px",
                            }
                        }
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                }}
                renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                    return <MenuItem
                        key={el.type}
                        onClick={() => {
                            el.handler(row.original)
                            closeMenu();
                        }}
                        disabled={row.original.estimate?.estimateState !== "PERFORMER_SELECTED"}
                        sx={{
                            margin: "0 8px",
                            borderRadius: "4px",
                            "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                        }}
                    >
                        {el.text}
                    </MenuItem>
                })}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                onGlobalFilterChange={(value) => {
                    handleSearchQuery(value, data, null)
                }}
                onColumnFiltersChange={(updater) => {
                    handleSearchQuery(updater(columnsFilter), data, null, true)
                }}
                onShowColumnFiltersChange={handleShowColumnFilters}
                state={{
                    showColumnFilters: showColumnFilters,
                    columnFilters: columnsFilter,
                    globalFilter: globalFilter,
                    showGlobalFilter: true,
                    pagination: tableOptions,
                }}
                manualFiltering={true}
                rowCount={tableOptions.totalElements}
                enableRowActions={!archive}
                enableToolbarInternalActions={false}
                columns={columns}
                data={filteredData}
                selectionPadding={1}
                getRowId={(originalRow) => originalRow.id}
                selectionCss={{
                    backgroundColor: 'lightblue',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: 'blue',
                    borderRadius: '4px',
                }}
                initialState={{
                    columnVisibility: {
                        id: false,
                        model: false,
                        year: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                }}
                muiToolbarAlertBannerChipProps={{color: 'primary'}}
                localization={MRT_Localization_RU}
            />
            <ModalConfirm
                title={"Подтвердить исполнение?"}
                modalOpen={setPurchaseModalOpen}
                handleClose={() => setSetPurchaseModalOpen(false)}
                handleSubmit={handleSubmitSetPurchase}
                action={"Подтвердить"}
            />
        </Box>
    );
};

export default OrderCloudTable;